import React, {PropTypes} from 'react';
import {Panel, Row, Col, Button, Glyphicon, OverlayTrigger, Tooltip} from 'react-bootstrap';
import TagsSuggest from './TagsSuggest';
import {FormattedMessage, FormattedHTMLMessage} from 'react-intl';
import MultiSelect from '../../ui/components/MultiSelect';
import RSSFeed from '../../home/components/RSSfeed';
import Link from '../../routing/components/Link';

const tooltip = (
  <Tooltip id="tooltip"><FormattedHTMLMessage id="quoteTip"/></Tooltip>
);

const AdvancedSearchBar = props => {
  let {query, queryObjChange, startSearch, publications, children, feedURI, tagIndexRoute, typeOptions, lawIndexRoute} = props;
  let filters = query.filters;

  let publicationOptions = publications.sort((a, b) => {
    return a.order < b.order ? -1 : 1;
  }).map(publication => {
    return {value: publication.canonical, label: publication.label};
  });

  let filterChange = (type, value) => {
    let obj = query;
    if (value) {
      obj.filters[type] = value;
    }
    else {
      delete obj.filters[type];
    }
    return obj;
  };

  let handleClear = event => {
    query.query = '';
    queryObjChange(query);
  };

  let handleTyping = event => {
    query.query = event.target.value;
    queryObjChange(query);
  };

  let handleKey = event => {
    if (event.keyCode === 13) {
      startSearch();
    }
  };

  return (
    <div className="searchbar">
      {children || null}
      <div className="simplecontainer">
        {/*Input Button*/}
        <div>
          <Row>
            <Col sm={12}>
              {/*Tags*/}
              <Panel header={<FormattedMessage id="searchTerm"/>} className="panel-invert">
                <p><FormattedMessage id="typeSearch"/></p>
                <div style={{position: 'relative'}}>
                  <input className="form-control" type="text" onChange={handleTyping} onKeyDown={handleKey} value={query.query || ''}/>
                  {query.query ? <span style={{position: 'absolute', right: 26, top: 8, zIndex: 999, cursor: 'pointer'}} onClick={handleClear}><Glyphicon
                    glyph="glyphicon glyphicon-remove"/></span> : ''}
                  <OverlayTrigger placement="bottom" overlay={tooltip}>
                    <Glyphicon glyph="info-sign" style={{position: 'absolute', right: 8, top: 11, zIndex: 999, cursor: 'pointer'}}/>
                  </OverlayTrigger>
                </div>
              </Panel>
            </Col>
          </Row>
          {/*Advanced*/}
          <Row>
            <Col sm={12}>
              {/*Tags*/}
              <Panel header={<span><FormattedMessage id="tags"/>&nbsp;(<Link url={tagIndexRoute}><FormattedMessage id="tagIndex"/></Link>)</span>}
                     className="panel-invert">
                <p><FormattedMessage id="typeTags"/></p>
                <TagsSuggest tags={filters.tags || []} onTagsChanged={(tags) => {
                  queryObjChange(filterChange('tags', tags));
                }} onEnter={startSearch}/>
              </Panel>
            </Col>
          </Row>
          <Row>
            <Col sm={12}>
              {/*Date Change*/}
              <Panel header={<span><FormattedMessage id="annotatedTexts"/>&nbsp;(<Link
                url={lawIndexRoute}><FormattedMessage id="toTheAnnotatedTexts"/></Link>)</span>} className="panel-invert">
                <MultiSelect options={publicationOptions} selected={filters.publication || []} onChange={(selected) => {
                  queryObjChange(filterChange('publication', selected));
                }}/>
              </Panel>
            </Col>
          </Row>
          {/*<Row>*/}
          {/*<Col sm={6}>*/}
          {/*/!*Date Change*!/*/}
          {/*<Panel bsStyle="info" header={<FormattedMessage id="effectiveDate"/>}>*/}
          {/*<DatePicker value={filters.date} onChange={handleChangeDate}/>*/}
          {/*</Panel>*/}
          {/*</Col>*/}
          {/*</Row>*/}
          <Row>
            <Col sm={12}>
              <Panel header={<FormattedMessage id="articleNumber"/>} className="panel-invert">
                <div style={{position: 'relative'}}>
                  <input className="form-control" type="text" value={filters.articleLabel || ''} onChange={(e) => {
                    queryObjChange(filterChange('articleLabel', e.target.value));
                  }} onKeyPress={(e) => {
                    if (e.key === 'Enter') {
                      startSearch();
                    }
                  }}/>
                  {filters.articleLabel ? <span style={{position: 'absolute', right: 8, top: 8, zIndex: 999, cursor: 'pointer'}} onClick={() => {
                    queryObjChange(filterChange('articleLabel', null));
                  }}><Glyphicon
                    glyph="glyphicon glyphicon-remove"/></span> : ''}
                </div>
              </Panel>
            </Col>
          </Row>
          <Row>
            <Col sm={12}>
              {/*Type Change*/}
              <Panel header={<FormattedMessage id="type"/>} className="panel-invert">
                <MultiSelect options={typeOptions} selected={filters.type || []} onChange={(selected) => {
                  queryObjChange(filterChange('type', selected));
                }}/>
              </Panel>
            </Col>
            {/*<Col sm={6}>*/}
            {/*<Panel bsStyle="info" header={<FormattedMessage id={'language'}/>}>*/}
            {/*<MultiSelect options={languageOptions} selected={filters.language || []} onChange={(selected) => {*/}
            {/*queryObjChange(filterChange('language', selected))*/}
            {/*}}/>*/}
            {/*</Panel>*/}
            {/*</Col>*/}
          </Row>
        </div>
        <div>
          <Button bsStyle="secundary" onClick={startSearch} className="btn-sm" title="Click"><i className="fa fa-search"></i>&nbsp;&nbsp;<FormattedMessage
            id="search"/></Button>
          &nbsp;&nbsp;
          <a className="btn btn-link" onClick={() => {
            queryObjChange({
              query: '',
              filters: {}
            });
          }}><FormattedMessage id="clearOptions"/></a>
          &nbsp;&nbsp;
          {/*
          RSS-feeds are temporarely commented out.
          {feedURI ? <RSSFeed feedURI={feedURI}/> : null}

          */}
        </div>
      </div>
    </div>
  );
};

AdvancedSearchBar.propTypes = {
  query: PropTypes.object.isRequired,
  queryObjChange: PropTypes.func.isRequired,
  startSearch: PropTypes.func.isRequired,
  publications: PropTypes.array.isRequired,
  children: PropTypes.object,
  feedURI: PropTypes.string,
  tagIndexRoute: PropTypes.string,
  lawIndexRoute: PropTypes.string,
  typeOptions: React.PropTypes.array
};

export default AdvancedSearchBar;



/** WEBPACK FOOTER **
 ** ./src/modules/search/components/AdvancedSearchBar.js
 **/